import React from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import {
  Home,
  Info,
  ContactMail,
  Close,
  People,
  Build,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Sidebar = ({ open, onDrawerToggle }) => {
  const navigate = useNavigate();

  const menuItems = [
    { text: 'Home', icon: <Home />, path: '/' },
    { text: 'About Us', icon: <Info />, path: '/about' },
    { text: 'Contact Us', icon: <ContactMail />, path: '/contact' },
    { text: 'My Toolkit', icon: <Build />, path: '/toolkit' },
    { text: 'Members Area', icon: <People />, path: '/members' },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    onDrawerToggle(false);
  };

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={() => onDrawerToggle(false)}
      sx={{
        '& .MuiDrawer-paper': {
          width: 280,
          backgroundColor: '#ffffff',
        },
      }}
    >
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" color="primary">
          Menu
        </Typography>
        <IconButton onClick={() => onDrawerToggle(false)}>
          <Close />
        </IconButton>
      </Box>
      <Divider />
      <List sx={{ pt: 1 }}>
        {menuItems.map((item) => (
          <ListItem 
            button 
            key={item.text} 
            sx={{ pl: 2 }}
            onClick={() => handleNavigation(item.path)}
          >
            <ListItemIcon sx={{ color: '#89479a' }}>
              {item.icon}
            </ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default Sidebar;
